import {useMemo} from 'react'
import isNil from 'lodash/isNil.js'

import FormattedRateCost from '../../../../../common/components/FormattedRateCost.js'
import ButtonLink from '../../../../../common/components/Button/ButtonLink.js'

import {shippedShippingMethodNameSelector} from '../../../../../data/orders.js'
import {
  makeCostSelector,
  orderNumberFromLabelConfigSelector,
  labelShipperTypeSelector,
  labelShippingMethodNameSelector,
} from '../../../../../data/labelInfos/index.js'

import {setSelectedOrderNumbers} from '../../../orderListActions.js'
import {
  SHIPPING_TAB,
  setOrderActionPanelCurrentTab,
} from '../../../ActionPanel/orderActionPanelFunctions.js'
import {useSelector} from '../../../../../store.js'
import {useLabelConfigContext} from '../../../../LabelConfig/LabelConfigContext.js'
import {shipperCurrencySymbolSelector} from '../../../../../data/shippers.js'

export default function CompactRateDetails() {
  const {labelInfoID} = useLabelConfigContext()
  const shipperType = useSelector((state) =>
    labelShipperTypeSelector(state, {labelInfoID}),
  )
  const orderNumber = useSelector((state) =>
    orderNumberFromLabelConfigSelector(state, {labelInfoID}),
  )

  const costSelector = useMemo(() => makeCostSelector(), [])

  const displayShippingMethod = useSelector((state) =>
    shippedShippingMethodNameSelector(state, {
      orderNumber,
    }),
  )
  const shippingMethod = useSelector(
    (state) =>
      displayShippingMethod ||
      labelShippingMethodNameSelector(state, {labelInfoID}),
  )

  const cost = useSelector((state) => costSelector(state, {labelInfoID}))
  const shipperCurrencySymbol = useSelector((state) =>
    shipperCurrencySymbolSelector(state, {shipperType}),
  )

  const showLabelTab = () => {
    setOrderActionPanelCurrentTab(SHIPPING_TAB)
    setSelectedOrderNumbers([orderNumber])
  }

  if (!shippingMethod) {
    return (
      <div>
        <ButtonLink className="v-align-base fs-n1" onClick={showLabelTab}>
          Create a label
        </ButtonLink>
      </div>
    )
  }

  return (
    <div>
      <ButtonLink className="darker v-align-base" onClick={showLabelTab}>
        <span
          className={`inline-block v-align-top selected-shipper selected-shipper--${shipperType}`}
        />
        <span className="fs-n1">{shippingMethod}</span>
        {!isNil(cost) && (
          <span>
            <span className="fs-n1"> - </span>
            <span className="fs-n1">
              <FormattedRateCost
                cost={cost}
                currencySymbol={shipperCurrencySymbol}
              />
            </span>
          </span>
        )}
      </ButtonLink>
    </div>
  )
}
